import LogoutContainer from "../../modules/auth/containers/Logout";

export default LogoutContainer();
